document.querySelectorAll('.header__toggle').forEach(element => {
    element.addEventListener('click', function () {
        this.classList.toggle('close-btn');
        document.querySelectorAll('.header').forEach(header => {
            header.classList.toggle('is-open');
        });
    });
});

document.querySelectorAll('button.header__nav-label').forEach(button => {
    button.addEventListener('click', function () {
        if (!this.classList.contains('is-active')) {
            document.querySelectorAll('.header__nav-label.is-active').forEach(activeLabel => {
                activeLabel.classList.toggle('is-active');
            });
            document.querySelectorAll('.header__nav-menu.is-open').forEach(openMenu => {
                openMenu.classList.toggle('is-open');
            });
        }
        this.classList.toggle('is-active');
        this.nextElementSibling.classList.toggle('is-open');
    });
});

document.querySelectorAll('button.header__nav-label').forEach(button => {
    button.addEventListener('mouseenter', function () {
        if (!this.classList.contains('is-active')) {
            document.querySelectorAll('.header__nav-label.is-active').forEach(activeLabel => {
                activeLabel.classList.toggle('is-active');
            });
            document.querySelectorAll('.header__nav-menu.is-open').forEach(openMenu => {
                openMenu.classList.toggle('is-open');
            });
        }
    });
});
